'use client';

import { useEffect } from 'react';
import { registerDefaultWindowDevTools } from '@web-store-platforms/dev-tools';

export function FontPreviewInitializer(): null {
    useEffect(() => registerDefaultWindowDevTools(), []);

    return null;
}
